import React from "react";
import { Alert } from "react-bootstrap";
import "./errorMessages.scss";
import { Link } from "react-router-dom";

export const ErrorMessages = (props) => {
  return (
    <>
      <Alert key="danger" className={props.className}>
        {props.text}
        {props.link ? (
          <Alert.Link href={props.link}>correct format</Alert.Link>
        ) : (
          ""
        )}
        {props.getInTouch ? <Link to={props.getInTouch}>call us.</Link> : ""}
        {props.tooltip ? "tooltip" : ""}
      </Alert>
    </>
  );
};
